export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-arrows-compress-0683155d665c5fc7c9a99514a907ead0.svg";